const radioHeight = (width: number, height: number) => {
  let percent = width / 350;
  return Math.floor(height / percent);
};

export interface IWaterItem {
  [key:string]: any;
  width?: number;
  height?: number;
}

export default function(original: any[]) {

  let column1 = [] as IWaterItem[];
  let column2 = [] as IWaterItem[];

  let column1height = 0;
  let column2height = 0;

  original.forEach((it: IWaterItem, index: number) => {
    const one = {
      ...it,
      originalIndex: index
    };
    
    if (column1height <= column2height) {
      column1.push(one);
      column1height += radioHeight(Number(one.width), Number(one.height));
    } else {
      column2.push(one);
      column2height += radioHeight(Number(one.width), Number(one.height));
    }
  });

  return [column1, column2];
}
